import { Box, Grid } from "@mui/material";
import { useState } from "react";
import WizardStep from "../../../components/Wizard/WizardStep";
import { AIOption, AIOptionGroup, ValidationError } from "../AI-Types";
import ErrorText from "./ErrorText";
import OptionList from "./OptionList";


type Props = {
    onCancel: () => void,
    roles: AIOptionGroup[],
    role?: AIOption,
    onNext: (role: AIOption) => void
    onPrevious: () => void
}

const RoleSelector = ({ onNext, onCancel, onPrevious, role, roles }: Props) => {
    const [values, setValues] = useState({ role });
    const [hasError, setHasError] = useState(false);

    const handleNext = () => {
        setHasError(false);

        if (!values.role) {
            setHasError(true);
            return;
        }

        onNext(values.role);
    }

    return (
        <WizardStep onNext={handleNext} onCancel={onCancel} onPrevious={onPrevious}>
            <Box sx={{ mt: 5 }}>
                {roles.map((group, index) => <Grid key={group.id} container spacing={4} sx={{ mb: 2 }}>
                    <OptionList hideHeading={index !== 0} groupName='Assistant Role' selectedOption={values.role} onSelect={(updatedValue) => setValues({ ...values, role: updatedValue })} options={group.options}>
                        <ErrorText message={hasError && !values.role ? 'Please specify a goal' : undefined} />
                    </OptionList>
                </Grid>)}

            </Box>
        </WizardStep>
    )
}

export default RoleSelector;